<template>
  <div v-if="Object.keys(suggestions.companies).length">
    <p
      v-show="suggestions"
      class="p4"
    >
      <i
        class="material-icons left"
        data-icon="domain"
      />
      <span> {{ locales.companies }} </span>
    </p>
    <div
      v-show="suggestions"
      class="card"
    >
      <div class="card-content suggestions-grid">
        <company-item
          v-for="company in suggestions.companies"
          :key="company.id"
          :company="company"
        />
      </div>
    </div>
    <div
      v-if="Object.keys(suggestions.industries).length || Object.keys(suggestions.locations).length"
      class="row"
    >
      <div
        v-show="suggestions.industries.length > 0"
        class="col s12 industries"
        :class="suggestions.industries.length > 0 && suggestions.locations.length == 0 ? '' : 'l6'"
      >
        <p class="p4">
          <i
            class="material-icons left"
            data-icon="work"
          />
          <span> {{ locales.matching_industries }} </span>
        </p>
        <div class="card">
          <div class="card-content suggestions-grid other">
            <a
              v-for="industry in suggestions.industries"
              :key="industry.id"
              class="p4 truncate"
              href="#"
              @click.prevent="handleClickForSuggestion(industry)"
            >
              {{ industry.name }}
              <div class="separation-line" />
              <p class="p5">
                {{ industry.id }}
              </p>
            </a>
          </div>
        </div>
      </div>
      <div
        v-show="suggestions.locations.length > 0"
        class="col s12 locations"
        :class="suggestions.locations.length > 0 && suggestions.industries.length == 0 ? '' : 'l6 pl'"
      >
        <p class="p4">
          <i
            class="material-icons left"
            data-icon="pin_drop"
          />
          <span> {{ locales.locations_name }} </span>
        </p>
        <div class="card">
          <div class="card-content suggestions-grid other">
            <a
              v-for="location in suggestions.locations"
              :key="location.id"
              class="p4 truncate"
              href="#"
              @click.prevent="handleClickForSuggestion(location)"
            >
              {{ location.name }}
              <div class="separation-line" />
              <p class="p5">
                {{ location.type_name }}
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SuggestionsBoard',
  components: {
    CompanyItem: () => import('./company_item.vue')
  },
  props: {
    suggestions: {
      type: Object,
      default: () => {}
    },
    locales: {
      type: Object,
      default: () => {}
    },
    fetch_url: {
      type: String,
      default: ''
    },
    locale: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClickForSuggestion(suggestion_object) {
      suggestion_object = {
        ...suggestion_object,
        priority: 1,
        uid: suggestion_object.id
      }
      this.$parent.$emit('addFilterToFilters', suggestion_object)
      this.$parent.$emit('submitRequest')
    },
  }
}
</script>